import { Row, Tooltip } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { FormCheckBox } from '../crmFormElement/FormInput';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import { setNonSelectedDiscrepency, setSelectedDiscrepency } from '../../../store/actions/newAdmissionAction';
import {ReactComponent as InformationIcon} from '../../../assets/images/svg/i_new_info_icon.svg';

const DiscrepencyClassificationQuestion = ({
    classification, onChangeQuestion, fileNames: options, checked, setFinalAnswer, checkedList, form, index, showInfoIcon,
}: any): ReactElement => {
    // const { questionText, questionType } = classification;
    const { questionType } = classification;
    const { payerList:
        { payer: { showOtherBuddhimedFlow } },
    }: any = useSelector((state: RootState): RootState => state);
    const { nonAvailableClassification, uploadedFiles } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
    const dispatch = useDispatch();
    if (classification && classification?.isSelectFile === true) {
        const currentFormValues = form?.getFieldsValue();
        if (classification?.answer === 'yes' && classification?.isSelectFile === true) {
            currentFormValues[classification?.questionType] = [classification?.questionType];
            // currentFormValues[classification?.questionText] = classification?.fileName;
        } else {
            currentFormValues[classification?.questionType] = undefined;
        }
        form.setFieldsValue(currentFormValues);
    }

    useEffect((): any => {
        if (nonAvailableClassification?.length) {
            const notSelectedItems: any[] = [];
            const selectedItems: any[] = [];

            nonAvailableClassification?.forEach((item: any): any => {
                if (!item?.isSelectFile) {
                    notSelectedItems?.push(item);
                } else {
                    selectedItems?.push(item);
                }
            });
            dispatch(setSelectedDiscrepency(notSelectedItems));
            dispatch(setNonSelectedDiscrepency(selectedItems));
        }
    }, [nonAvailableClassification]);

    return (
        <>
            {(showOtherBuddhimedFlow && uploadedFiles?.length) &&
                <Row gutter={GUTTOR_SPACE} style={{ fontWeight: '560' }}>
                    <FormCheckBox
                        detail={{
                            key: questionType,
                            suffixTestId: form,
                            options: [{
                                value: questionType, key: questionType, name: questionType, onChange: onChangeQuestion,
                                required: false,
                            }],
                            hideLabel: true,
                            checked: false,
                        }} />
                    {/* <FormSelect detail={{
                        key: questionText,
                        label: 'Select File',
                        options,
                        size: 12,
                        hideLabel: true,
                        allowClear: false,
                        placeholder: 'Select the relevant document',
                        onChange: setFinalAnswer,
                        rules: [{ required: false, message: 'File selection is required.' }],
                    }} /> */}
                    {(index < 3 && showInfoIcon) ? (
                        <Tooltip title="" placement="right">
                            <span style={{ marginLeft: '-16px', marginTop: '6px' }}><InformationIcon /></span>
                        </Tooltip>
                    ) : null}
                </Row>}
        </>
    );
};

export default DiscrepencyClassificationQuestion;
